import React from 'react';
import { CheckIcon, FingerprintIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { ForensicMotif } from './ui/ForensicMotif';
import { assurances, checkoutUrl, productBrand, productEdition } from '../data/offer';
export function FinalCta() {
  return <section className="relative isolate overflow-hidden bg-navy py-16 sm:py-20" aria-labelledby="final-title" data-id="element-58" data-mp="15ddhr7trttih">
      <ForensicMotif side="left" data-id="element-59" data-mp="1jcvd661ko50t" />
      <div className="mx-auto max-w-3xl px-4 text-center" data-id="element-60" data-mp="1jbtzrux336fx">
        <h2 id="final-title" className="text-balance text-3xl font-extrabold uppercase tracking-tight text-ivory sm:text-4xl" data-id="element-61" data-mp="1eebmxtfy472n">
          <span className="inline-flex items-center gap-2" data-id="element-62" data-mp="1t1wp9l4zy29i">
            <FingerprintIcon className="h-8 w-8 shrink-0 text-gold" aria-hidden="true" data-id="element-63" data-mp="1o3v6z2fea6z3" /> {productBrand}
          </span>
          <span className="mt-2 block text-xl font-extrabold uppercase tracking-[.16em] text-gold sm:text-2xl" data-id="element-64" data-mp="2233b89qf05a5">
            {productEdition}
          </span>
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-lg leading-relaxed text-ivory/80" data-id="element-65" data-mp="1x2p0ul1ccj8y">
          Creata per insegnanti di scienze della scuola secondaria.
        </p>

        <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" arrow className="mt-8 w-full sm:w-auto" data-id="element-66" data-mp="s57hbazoa2uy">
          Ottieni ora l&apos;Edizione Docenti
        </Button>

        <ul className="mt-8 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-ivory/80" data-id="element-67" data-mp="123wni6i7hyvd">
          {assurances.map(item => <li key={item} className="inline-flex items-center gap-1.5" data-id="element-68" data-mp="162dyj14qzti2">
              <CheckIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-69" data-mp="1b28mowx524zf" /> {item}
            </li>)}
        </ul>
      </div>
    </section>;
}